import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { getMetadataTags, getRouteMetadata } from '@/lib/metadata/routeMetadata';

/** Keep SPA navigations aligned with the metadata in each initial HTML entry. */
export function RouteMetadata() {
  const { pathname } = useLocation();

  useEffect(() => {
    const metadata = getRouteMetadata(pathname);
    document.title = metadata.title;
    for (const tag of getMetadataTags(metadata)) {
      const matches = document.head.querySelectorAll<HTMLMetaElement>(
        `meta[${tag.attribute}="${tag.key}"]`,
      );
      const element = matches[0] ?? document.createElement('meta');
      element.setAttribute(tag.attribute, tag.key);
      element.content = tag.content;
      if (!matches.length) document.head.appendChild(element);
      for (const duplicate of [...matches].slice(1)) duplicate.remove();
    }
  }, [pathname]);

  return null;
}
